import { useContext } from "react";
import StoreContext from "../context/store";
import { useCurrentFormatCurrency } from "./usePrices";
import { useLocalizedSentenceDict } from "./useSentenceDict";

export function useShippingInfo() {
  const context = useContext(StoreContext);
  return context?.store?.shippingFees;
}

export function useShippingMessage() {
  const shippingInfo = useShippingInfo();
  const dict = useLocalizedSentenceDict();
  const formatCurrency = useCurrentFormatCurrency();

  if (shippingInfo?.freeShippingThreshold === 0) {
    return dict.get("Free Shipping");
  }

  return dict.get(`Free shipping above {0}`, formatCurrency(shippingInfo?.freeShippingThreshold));
}
